export const getRouteParam = <T>(value: T | T[]) => (Array.isArray(value) ? value[0] : value) ?? '';
